import n from "./design-system.es58.js";
import { resolveComponent as c, openBlock as t, createElementBlock as r, normalizeClass as m, renderSlot as i, createBlock as l, createCommentVNode as s, createTextVNode as d, toDisplayString as _ } from "vue";
/* empty css                    */
import p from "./design-system.es128.js";
const f = {
  name: "DsTabHeaderItem",
  components: { Icon: n },
  props: {
    active: Boolean,
    icon: String,
    label: String
  }
};
function u(o, b, e, I, v, k) {
  const a = c("Icon");
  return t(), r("li", {
    class: m(["tab-header-item", { "tab-header-item-active": e.active }])
  }, [
    i(o.$slots, "default", {}, () => [
      e.icon ? (t(), l(a, {
        key: 0,
        name: e.icon
      }, null, 8, ["name"])) : s("", !0),
      d(" " + _(e.label), 1)
    ], !0)
  ], 2);
}
const x = /* @__PURE__ */ p(f, [["render", u], ["__scopeId", "data-v-1a6c1338"]]);
export {
  x as default
};
//# sourceMappingURL=design-system.es99.js.map
